var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6349 0.377576C16.5155 0.257888 16.3738 0.16293 16.2177 0.0981401C16.0617 0.0333498 15.8944 0 15.7254 0C15.5564 0 15.3891 0.0333498 15.2331 0.0981401C15.077 0.16293 14.9353 0.257888 14.8159 0.377576L8.51264 6.67667L2.20936 0.369567C1.96662 0.141013 1.64471 0.0156332 1.31143 0.0198301C0.978144 0.0240271 0.659491 0.157473 0.422576 0.392067C0.18566 0.626661 0.0489704 0.944094 0.0412922 1.27752C0.0336139 1.61094 0.155546 1.93434 0.381411 2.1796L6.68469 8.4867L0.381411 14.7938C0.138612 15.0348 0.00141819 15.3624 1.09331e-05 15.7045C-0.00139632 16.0467 0.133098 16.3754 0.373908 16.6184C0.614717 16.8613 0.942115 16.9986 1.28408 17C1.62604 17.0014 1.95456 16.8668 2.19736 16.6259L8.50064 10.3188L14.8039 16.6259C15.0473 16.8564 15.371 16.9829 15.7061 16.9783C16.0412 16.9737 16.3614 16.8385 16.5984 16.6013C16.8353 16.3642 16.9705 16.0439 16.9751 15.7086C16.9797 15.3732 16.8533 15.0493 16.6229 14.8058L10.3196 8.49872L16.6229 2.19162C16.8623 1.95127 16.9977 1.6264 17 1.28706C17.0022 0.947711 16.8711 0.621075 16.6349 0.377576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.1dd13a73b39d653c26614cfbf3c30ba0.svg";
export { ForwardRef as ReactComponent };